import React from "react";
import ReactDOMServer from "react-dom/server";
import ReactMarkdown from "react-markdown";

export const hasMarkdown = text =>
  ReactDOMServer.renderToString(<ReactMarkdown>{text}</ReactMarkdown>)
  !== `<p>${text}</p>`;
